export const ENTITY_FINDER_ROW_HEIGHT = 60;
export const ENTITY_FINDER_ROW_HEIGHT_NO_SUBTITLE = 52;
export const SECTION_HEADER_HEIGHT = 40;
export const ENTITY_FINDER_GUTTER_X = "px-4";
export const ENTITY_FINDER_ROW_PADDING = "px-2 py-2";
export const ENTITY_FINDER_LIST_BOTTOM_PADDING = "pb-3";
export const ENTITY_FINDER_LIST_BOTTOM_PADDING_PX = 5;
export const ENTITY_FINDER_PANEL_MAX_HEIGHT = "min(32rem, 56vh)";
export const ENTITY_FINDER_EXPANDED_WIDTH = "min(40rem, 44vw)";
export const ENTITY_FINDER_EXPANDED_WIDTH_CLS = "w-[min(40rem,44vw)]";
export const ENTITY_FINDER_RECENT_MAX = 6;
export const ENTITY_FINDER_DEBOUNCE_MS = 300;

/** Entity finder open/close choreography (ms) */
export const ENTITY_FINDER_OPEN_DELAY_MS = 60;
export const ENTITY_FINDER_POPOVER_CLOSE_MS = 140;
export const ENTITY_FINDER_INPUT_ANIMATION_MS = 220;
export const ENTITY_FINDER_PANEL_FADE_MS = 120;

/** Typography tokens — one step up from prior scale, capped at text-base */
export const ENTITY_FINDER_TITLE_CLS = "text-base font-medium text-foreground";
export const ENTITY_FINDER_SUBTITLE_CLS = "text-sm text-muted-foreground";
export const ENTITY_FINDER_SECTION_CLS = "text-sm font-medium text-muted-foreground";
export const ENTITY_FINDER_META_CLS = "text-xs font-normal leading-snug tabular-nums";
export const ENTITY_FINDER_FOOTER_CLS = "text-sm text-muted-foreground";
export const ENTITY_FINDER_FOOTER_CHIP_CLS = "text-xs text-secondary-foreground";
export const ENTITY_FINDER_INPUT_CLS = "text-base";
export const ENTITY_FINDER_KBD_CLS = "text-xs font-medium text-muted-foreground";
export const ENTITY_FINDER_HELPER_CLS = "text-sm text-muted-foreground";
export const ENTITY_FINDER_EMPTY_TITLE_CLS = "text-base font-medium text-foreground";
